import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicBody from '../EpicBody/epic.body.vue';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
// import VueRecaptcha from 'vue-recaptcha';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        EpicBody,
        ASpaceInBetweenAnother,
        // VueRecaptcha,
    }
})
export default class EpicFooter extends Vue {
    public title: string = 'EpicFooter';

    public stayConnectedAddr: string = '';

    public configs = new CommonConfig();

    public mySocialMedias: any[] = [
        {
            name: 'twitter',
            link: 'https://twitter.com/rifoholdings?lang=en',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-social-medias/twitter_1.svg',
        },
        {
            name: 'ins',
            link: '',
            icon: '',
        },
        {
            name: 'fb',
            link: 'https://www.facebook.com/rifoholdings/',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-social-medias/face.svg',
        },
        {
            name: 'be',
            link: '',
            icon: '',
        },
        {
            name: 'link',
            link: 'https://www.linkedin.com/company/rifo-holding-group',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-social-medias/link.svg',
        },
        {
            name: 'youtube',
            link: '',
            icon: '',
        },
    ];

    public myLinks: any[] = [
        {
            name: 'Home',
            link: '/',
            icon: '',
        },
        {
            name: 'Buyers Guide',
            link: '/buyer-guide',
            icon: '',
        },
        {
            name: 'Sellers Guide',
            link: '/seller-guide',
            icon: '',
        },
        {
            name: 'Download',
            link: '/download-app',
            icon: '',
        },
        // {
        //     name: 'All Homes',
        //     link: '/map',
        //     icon: '',
        // },
        {
            name: 'News',
            link: '/news-list/all',
            icon: '',
        },
        {
            name: 'About Us',
            link: '/about-us',
            icon: '',
        },
        {
            name: 'Contact Us',
            link: '/contact-us',
            icon: '',
        },
        {
            name: 'Privacy Policy',
            link: '/privacy-policy',
            icon: '',
        },
        {
            name: 'Terms Of Service',
            link: '/terms-of-service',
            icon: '',
        },
        {
            name: 'Acceptable Use Policy',
            link: '/acceptable-use-policy',
            icon: '',
        },
        {
            name: 'Terms Of Use',
            link: '/terms-of-use',
            icon: '',
        }
    ];

    public partnerSites: {link: string, name: string}[] = [
        { link: 'www.en.queenfinancial.com', name: 'www.en.queenfinancial.com' },
        { link: 'www.royalpacific.com', name: 'www.royalpacific.com' },
        { link: 'www.realjaja.com', name: 'www.realjaja.com' },
        { link: 'www.uniliferealty.ca', name: 'www.uniliferealty.ca' },
        { link: 'www.royaleliterealty.com', name: 'www.royaleliterealty.com' },
        { link: 'www.greenteamrealty.ca', name: 'www.greenteamrealty.ca' },
        { link: 'www.artsystaging.com', name: 'www.artsystaging.com' },
        { link: 'www.sciinnovationcentre.com', name: 'www.sciinnovationcentre.com' },
        { link: 'www.rarealtyalliance.com', name: 'www.rarealtyalliance.com' },
        { link: 'mastertrust.masterchoicegroup.com', name: 'mastertrust.masterchoicegroup.com' },
        { link: 'www.eastide.com', name: 'www.eastide.com' },
        { link: 'www.ccrpa.ca', name: 'www.ccrpa.ca' },
        { link: 'www.reco.on.ca', name: 'www.reco.on.ca ' },
        { link: 'www.beefinancegroup.com/home.html', name: 'www.beefinancegroup.com ' }
    ];

    public suppliers: string[] = [
        'queenfinance.com',
        'seek.com.au',
        'carsguide.com.au',
        'foxsports.com.au',
        'homeguru.com.au',
        'realestate.co.nz',
        'mansionglobal.com',
        'askizzy.org.au',
        'proptiger.com'
    ];

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
